module.exports = __webpack_public_path__ + "static/img/title_Cooperation.f49734c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join/title_Cooperation.png
// module id = LiJR
// module chunks = 0